import { FC, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { MentorEditContext } from '.';
import EditInformation from './EditInformation';
import GeneralInformation from './GeneralInformation';
import Interviews from './interviews';
import MentorForm from './MentorForm';
import Mentoring from './Mentoring';
import Training from './Training';

const MentorProfileRoutes: FC = () => {
  const { mentor } = useContext(MentorEditContext);

  return (
    <Routes>
      <Route path="" element={<GeneralInformation />} />
      <Route path="/edit-information" element={<EditInformation />} />
      <Route path="/form/" element={<MentorForm />} />
      <Route path="/training" element={<Training />} />
      <Route
        path="/mentoring/*"
        element={
          mentor?.mentorStatus === 'ACCEPTED' || mentor?.mentorStatus === 'AVAILABLE' ||
            mentor?.mentorStatus === 'MENTORSHIP_ACTIVE' ? (
              <Mentoring />
            ) : (
              <div>
                La partie Mentorat n'est pas disponible pour cet utilisateur.
              </div>
            )
        }
      />
      <Route path="/interviews" element={<Interviews />} />
      <Route path="/tools" element={<div>e</div>} />
      <Route path="/transaction-history" element={<div>f</div>} />
    </Routes>
  );
};

export default MentorProfileRoutes;
